// work data

export const Work = [
    {
        id:1,
        name:"Udemy Clone",
        description:"A responsive Udemy clone created using HTML, CSS, and JavaScript. It focuses on the frontend development only",
        tags:["html", "css", "javascript", "responsive"],
        
        demo:"https://prasath-udemy-clone.netlify.app",
        github:"https://github.com/mohan-prasath7/Udemy"
    },
    {
        id:2,
        name:"Google Clone website",
        description:"A pixel-perfect, responsive recreation of the Google homepage.Built using HTML and CSS, with JavaScript for added interactivity.",
        tags:["html", "css", "javascript", "frontend", "responsive"],
        
        demo:"https://prasath-google-clone.netlify.app/",
        github:"https://github.com/mohan-prasath7/Google-Clone-page"
        
    },
    {
        id:3,
        name:"Kitter Pet Food Website",
        description:"A stylish and responsive website for Kitter pet food, showcasing products with a sleek, user-friendly design.",
        tags:["html", "css", "javascript", "webdesign"],
        
        demo:"https://prasath-kitter-app.netlify.app/",
        github:"https://github.com/mohan-prasath7/Kitter"
        
    }
    ,
    {
        id:4,
        name:"Calculator",
        description:"A simple yet functional calculator created using HTML, CSS, and JavaScript. It includes basic arithmetic operations with a clean and responsive user interface.",
        tags:["html", "css", "javascript", "calculator"],
        
        demo:"https://prasath-calculator.netlify.app/",
        github:"https://github.com/mohan-prasath7/Calculator-"
       
    },
    {
        id:5,
        name:"Responsive Todo List",
        description:"A fully responsive todo list application created using HTML, CSS, and JavaScript. It allows users to add, delete, and manage tasks with an intuitive user interface.",
        tags:["html", "css", "javascript", "todoapp"],
        
        demo:"https://prasath-todo-list.netlify.app/",
        github:"https://github.com/mohan-prasath7/Todo-list"
    },
    {
        id:6,
        name:"Recipe Finder",
        description:"A fun and interactive recipe finder that generates random recipes at the click of a button. Built using HTML, CSS, and JavaScript.",
        tags:["html", "css", "javascript", "recipe", "webapp"],
        
        demo:"https://prasath-receipe-book.netlify.app/",
        github:"https://github.com/mohan-prasath7/Receipe"
        
    },
    
  
] 